/* YSL FEEL MYSLF — fragrance quiz engine (mobile only).
   Copy + scoring are LITERAL here (fixed brand content, per ysl-section-guide §5).
   Media URLs + product links come from the #ysl-myslf-data JSON the section emits.
   Scoring matrix ported from "YSL Men Repush - MYSLF QUIZZ" CSV.
   Product score keys: edp / absolu / leparfum / edti.
   Q4 ("vệt hương") uses the CSV's tuned Q5 weights (sharper separation).      */
(function () {
  'use strict';

  var QUESTIONS = [
    {
      id: 'q1',
      widget: 'dial',
      prompt: 'Khởi đầu ngày mới, đâu là nguồn năng lượng bạn muốn hướng tới?',
      options: [
        { key: 'A', label: 'THOẢI MÁI & GỌN GÀNG', sub: 'Chỉn chu, tự tin mà không cần cố tỏ ra nổi bật.', score: { edp: 2, edti: 1 } },
        { key: 'B', label: 'SẢNG KHOÁI & TỰ DO', sub: 'Sẵn sàng cho những trải nghiệm mới đầy ngẫu hứng.', score: { edp: 1, absolu: 2 } },
        { key: 'C', label: 'TĨNH LẶNG & VỮNG CHÃI', sub: 'Tập trung tuyệt đối vào bản thân trước mọi sự ồn ào.', score: { leparfum: 2, edti: 1 } }
      ]
    },
    {
      id: 'q2',
      widget: 'bubbles',
      prompt: 'Sau một cuộc gặp gỡ, bạn muốn người khác nhớ gì về mình?',
      options: [
        { key: 'A', label: 'MỘT NGƯỜI TINH TẾ VÀ DỄ CHỊU', sub: 'Sự quyến rũ đến từ vẻ tự nhiên, không gượng ép.', score: { edp: 2 } },
        { key: 'B', label: 'MỘT NGƯỜI THÚ VỊ VÀ TRÀN ĐẦY SỨC SỐNG', sub: 'Ở cạnh luôn thấy thoải mái, nhẹ nhàng và phóng khoáng.', score: { absolu: 2 } },
        { key: 'C', label: 'MỘT NGƯỜI THẦM LẶNG NHƯNG ĐẦY BẢN LĨNH', sub: 'Tập trung tuyệt đối vào bản thân trước mọi sự ồn ào.', score: { leparfum: 1, edti: 3 } }
      ]
    },
    {
      id: 'q3',
      widget: 'segment',
      prompt: 'Đâu là giá trị bạn luôn giữ cho riêng mình?',
      options: [
        { key: 'A', label: 'BẢN SẮC TỰ NHIÊN', sub: 'Hiểu rõ chính mình và không cần phô trương.', score: { edp: 2 } },
        { key: 'B', label: 'THẾ GIỚI NỘI TÂM ĐỘC LẬP', sub: 'Sự vững vàng, mạnh mẽ đến từ sâu bên trong.', score: { absolu: 2 } },
        { key: 'C', label: 'BẢN NĂNG BỨT PHÁ', sub: 'Không để bất kỳ giới hạn hay khuôn mẫu nào đóng khung bản thân.', score: { leparfum: 2, edti: 1 } }
      ]
    },
    {
      id: 'q4',
      widget: 'slider',
      prompt: 'Nếu phong thái của bạn được hữu hình hóa thành một vệt hương, đó sẽ là:',
      options: [
        { key: 'A', label: 'VỆT NẮNG NHẸ SAU CƠN MƯA', sub: 'Sạch sẽ, êm dịu hòa vào da thịt — chỉ ai ở thật gần mới cảm nhận được.', score: { edp: 1, edti: 3 } },
        { key: 'B', label: 'LUỒNG GIÓ LẠNH BÙNG LÊN GIỮA SA MẠC', sub: 'Rực rỡ, sắc sảo và mang lại cảm giác tự do ngay lập tức.', score: { absolu: 2 } },
        { key: 'C', label: 'ĐỐM LỬA ÂM Ỉ TRONG CĂN PHÒNG TỐI', sub: 'Trầm ấm, nồng nàn và bám tỏa bền bỉ — hương nói nhưng đầy uy quyền.', score: { leparfum: 3, edti: 1 } }
      ]
    }
  ];

  var TAGLINE = 'Cuộc gặp gỡ hiện đại của hương Hoa-Gỗ đối lập';
  var RESULTS = {
    edp: {
      variant: 'EAU DE PARFUM', title: 'TỰ TIN HIỆN ĐẠI', tagline: TAGLINE,
      desc: 'Không định kiến, không thỏa hiệp. MYSLF EDP là tuyên ngôn nam tính hiện đại: tự do, phóng khoáng và bản lĩnh làm chủ cuộc chơi theo cách riêng. Hương cam Bergamot và Hoa cam Tunisia tươi mát lan tỏa mượt mà trên nền gỗ hổ phách và hương cung Ambrofix, tạo nên mùi hương đa diện, tự tin và hiện đại.',
      notes: ['Tươi mới sảng khoái · CAM BERGAMOT', 'Bừng nở thanh lịch · HOA CAM', 'Ấm áp quyến rũ · HỢP HƯƠNG GỖ'],
      hair: 'Tóc cắt tỉa gọn gàng / Rẽ ngôi tự nhiên / Tóc mái mềm mại'
    },
    absolu: {
      variant: "L'ABSOLU", title: 'BỪNG SÁNG NĂNG LƯỢNG TÍCH CỰC', tagline: TAGLINE,
      desc: "Luôn tiến về phía trước. MYSLF L'Absolu là tuyên ngôn nam tính đầy bứt phá: tích cực, mạnh mẽ và tràn đầy năng lượng sống. Gừng tươi và Bạch đậu khấu thổi bùng làn gió lạnh sảng khoái, rồi chuyển mình trên nền gỗ hổ phách hương đậm đặc, tạo nên mùi hương bùng nổ và lôi cuốn.",
      notes: ['Bùng sáng sảng khoái · GỪNG', 'Bừng nở thanh lịch · HOA CAM', 'Ấm áp quyến rũ · HỢP HƯƠNG GỖ'],
      hair: 'Tóc mái có độ bồng bềnh / Tóc tỉa lớp rối / Tóc tỉa lớp kiểu sợi'
    },
    leparfum: {
      variant: 'LE PARFUM', title: 'SÂU SẮC TÁO BẠO', tagline: TAGLINE,
      desc: 'Dám nghĩ, dám làm. MYSLF Le Parfum là hiện thân của người đàn ông không ngại bộc lộ những thái cực đối lập, táo bạo và sâu sắc. Tiêu đen cay nồng đầy kích thích dẫn lối cho Hoa cam rang rõ và Vanilla Bourbon ngọt ấm, rồi sắc lại cùng hổ phách ấm áp, tạo nên chiều sâu bí ẩn nhưng đầy quyền lực.',
      notes: ['Ấm áp quyến rũ · HƯƠNG GỖ', 'Bừng nở thanh lịch · HOA CAM', 'Êm mượt gây nghiện · VANILLA'],
      hair: 'Tóc vuốt ngược / Tóc mái phồng hiện đại / Rẽ ngôi sắc nét'
    },
    edti: {
      variant: 'EAU DE TOILETTE INTENSE', title: 'HƯƠNG NỘI TINH TẾ', tagline: TAGLINE,
      desc: 'Không cần phô trương. MYSLF EDT Intense là tuyên ngôn của sự quyến rũ tự nhiên, khai phóng nét nam tính trầm tĩnh và lôi cuốn nhất. Nốt Hoa cam và khoảng chất mát lạnh lắng đọng, mở đường cho Xạ hương trắng và gỗ tối, tạo nên một vệt hương da thịt đầy tinh tế, phong trần.',
      notes: ['Ấm áp quyến rũ · HƯƠNG GỖ', 'Bừng nở thanh lịch · HOA CAM', 'Tinh khôi mê hoặc · XẠ HƯƠNG TRẮNG'],
      hair: 'Tóc tỉa lớp mềm mại / Tóc suôn tự nhiên / Kiểu tóc gọn gàng dễ chăm sóc'
    }
  };
  // Deterministic tie-break priority (first wins on equal score).
  var PRIORITY = ['edp', 'absolu', 'leparfum', 'edti'];

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    var data = {};
    var dataEl = $('#ysl-myslf-data', root);
    if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; } }
    var media = data.media || {};
    var products = data.products || {};

    var stage = $('.ysl-mq__stage', root);
    var bgLayer = $('.ysl-mq__bg', root);
    var btnBack = $('.ysl-mq__back', root);
    var btnPrimary = $('.ysl-mq__cta', root);
    var ctaLabel = $('.ysl-mq__cta-label', root);

    // Build the linear sequence of screens.
    // intro -> form -> [q-title, q-pick, q-reveal] x4 -> result
    var seq = [{ type: 'intro' }, { type: 'form' }];
    QUESTIONS.forEach(function (q, i) {
      seq.push({ type: 'title', q: i });
      seq.push({ type: 'pick', q: i });
      seq.push({ type: 'reveal', q: i });
    });
    seq.push({ type: 'result' });

    var answers = {};         // qid -> option index
    var idx = 0;
    var resultKey = null;

    var introScreen = $('[data-screen="intro"]', root);
    var formScreen = $('[data-screen="form"]', root);
    var dynScreen = $('[data-screen="dyn"]', root);   // reused container for title/pick/reveal
    var resultScreen = $('[data-screen="result"]', root);

    function setBg(url, isVideo, poster) {
      bgLayer.innerHTML = '';
      if (isVideo && url) {
        var v = document.createElement('video');
        v.src = url; v.autoplay = true; v.muted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('playsinline', ''); if (poster) v.poster = poster;
        bgLayer.appendChild(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (url) {
        var im = el('div', 'ysl-mq__bgimg');
        im.style.backgroundImage = 'url("' + url + '")';
        bgLayer.appendChild(im);
      }
    }

    function showOnly(node) {
      [introScreen, formScreen, dynScreen, resultScreen].forEach(function (n) {
        if (!n) return; n.classList.toggle('is-active', n === node);
      });
    }

    function render() {
      var step = seq[idx];
      btnBack.style.visibility = idx <= 1 ? 'hidden' : 'visible';

      if (step.type === 'intro') {
        showOnly(introScreen);
        setBg(media.introVideo, true, media.introPoster);
        btnPrimary.style.display = '';
        ctaLabel.textContent = 'BẮT ĐẦU TRẢI NGHIỆM';
        btnPrimary.onclick = next;
        return;
      }
      if (step.type === 'form') {
        showOnly(formScreen);
        setBg(media.formImage, false);
        btnPrimary.style.display = 'none';   // native submit button inside the form
        return;
      }
      if (step.type === 'result') { renderResult(); return; }

      // dynamic question screens
      var q = QUESTIONS[step.q];
      var qm = (media.questions && media.questions[step.q]) || {};
      if (step.type === 'title') {
        showOnly(dynScreen);
        setBg(qm.video, true, qm.poster);
        dynScreen.innerHTML =
          '<div class="ysl-mq__inner ysl-mq__inner--center">' +
            '<h2 class="ysl-mq__qtitle">' + esc(q.prompt) + '</h2>' +
          '</div>';
        btnPrimary.style.display = '';
        ctaLabel.textContent = 'TIẾP TỤC';
        btnPrimary.onclick = next;
        return;
      }
      if (step.type === 'pick') { renderPick(step.q); return; }
      if (step.type === 'reveal') { renderReveal(step.q); return; }
    }

    function renderPick(qi) {
      var q = QUESTIONS[qi];
      var qm = (media.questions && media.questions[qi]) || {};
      showOnly(dynScreen);
      setBg(qm.bg || qm.poster, false);
      var current = answers[q.id];

      var html = '<div class="ysl-mq__inner">' +
        '<p class="ysl-mq__prompt">' + esc(q.prompt) + '</p>' +
        '<div class="ysl-mq__widget ysl-mq__widget--' + q.widget + '" role="radiogroup">';
      q.options.forEach(function (o, i) {
        var on = current === i ? ' is-selected' : '';
        html += '<button type="button" class="ysl-mq__opt' + on + '" data-opt="' + i + '" role="radio" aria-checked="' + (current === i) + '">' +
          '<span class="ysl-mq__opt-label">' + esc(o.label) + '</span>' +
          '</button>';
      });
      html += '</div></div>';
      dynScreen.innerHTML = html;

      btnPrimary.style.display = '';
      ctaLabel.textContent = 'XÁC NHẬN';
      btnPrimary.disabled = current == null;
      root.classList.toggle('ysl-mq--cta-off', current == null);

      Array.prototype.forEach.call(dynScreen.querySelectorAll('.ysl-mq__opt'), function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-opt');
          answers[q.id] = i;
          Array.prototype.forEach.call(dynScreen.querySelectorAll('.ysl-mq__opt'), function (x) {
            var on = x === b; x.classList.toggle('is-selected', on); x.setAttribute('aria-checked', on);
          });
          btnPrimary.disabled = false;
          root.classList.remove('ysl-mq--cta-off');
        });
      });
      btnPrimary.onclick = function () { if (answers[q.id] != null) next(); };
    }

    function renderReveal(qi) {
      var q = QUESTIONS[qi];
      var qm = (media.questions && media.questions[qi]) || {};
      var o = q.options[answers[q.id]];
      showOnly(dynScreen);
      setBg(qm.reveal || qm.bg || qm.poster, false);
      dynScreen.innerHTML =
        '<div class="ysl-mq__inner ysl-mq__inner--reveal">' +
          '<p class="ysl-mq__prompt ysl-mq__prompt--dim">' + esc(q.prompt) + '</p>' +
          '<div class="ysl-mq__reveal">' +
            '<h3 class="ysl-mq__reveal-label">' + esc(o.label) + '</h3>' +
            '<p class="ysl-mq__reveal-sub">' + esc(o.sub) + '</p>' +
          '</div>' +
        '</div>';
      btnPrimary.style.display = '';
      ctaLabel.textContent = 'TIẾP TỤC';
      btnPrimary.disabled = false;
      root.classList.remove('ysl-mq--cta-off');
      btnPrimary.onclick = next;
    }

    function compute() {
      var totals = { edp: 0, absolu: 0, leparfum: 0, edti: 0 };
      QUESTIONS.forEach(function (q) {
        var ai = answers[q.id]; if (ai == null) return;
        var s = q.options[ai].score || {};
        Object.keys(s).forEach(function (k) { totals[k] += s[k]; });
      });
      var best = PRIORITY[0], bestV = -1;
      PRIORITY.forEach(function (k) { if (totals[k] > bestV) { bestV = totals[k]; best = k; } });
      return best;
    }

    function renderResult() {
      resultKey = compute();
      var r = RESULTS[resultKey];
      var p = products[resultKey] || {};
      showOnly(resultScreen);
      setBg((media.results && media.results[resultKey]) || media.formImage, false);
      btnPrimary.style.display = 'none';

      var notesHtml = r.notes.map(function (n) {
        var parts = n.split('·');
        return '<li class="ysl-mq__note"><span class="ysl-mq__note-cue">' + esc((parts[0] || '').trim()) + '</span>' +
          '<span class="ysl-mq__note-name">' + esc((parts[1] || '').trim()) + '</span></li>';
      }).join('');

      // Reuse the shared product card (rendered server-side, DISCOVER -> product page).
      var cardEl = root.querySelector('.ysl-mq__cards [data-result-card="' + resultKey + '"]');
      var bottle = p.image || (media.results && media.results[resultKey]) || '';
      var productBlock = cardEl
        ? '<div class="ysl-mq__rcard">' + cardEl.innerHTML + '</div>'
        : (bottle ? '<div class="ysl-mq__rbottle"><img src="' + esc(bottle) + '" alt="MYSLF ' + esc(r.variant) + '"></div>' : '');

      resultScreen.innerHTML =
        '<div class="ysl-mq__inner ysl-mq__inner--result">' +
          productBlock +
          '<p class="ysl-mq__reyebrow">NỐT HƯƠNG ĐẠI DIỆN CHO CHÍNH BẠN</p>' +
          '<p class="ysl-mq__rbrand">MYSLF</p>' +
          '<p class="ysl-mq__rvariant">' + esc(r.variant) + '</p>' +
          '<p class="ysl-mq__rtagline">' + esc(r.tagline) + '</p>' +
          '<h2 class="ysl-mq__rtitle">' + esc(r.title) + '</h2>' +
          '<p class="ysl-mq__rdesc">' + esc(r.desc) + '</p>' +
          '<p class="ysl-mq__rsig">FEEL MYSLF<br><span>Cảm nhận chất tôi. Sống trọn chất tôi.</span></p>' +
          '<ul class="ysl-mq__notes">' + notesHtml + '</ul>' +
          '<div class="ysl-mq__hair"><span class="ysl-mq__hair-h">KIỂU TÓC PHÙ HỢP VỚI PHONG CÁCH CỦA BẠN:</span>' +
            '<span class="ysl-mq__hair-t">' + esc(r.hair) + '</span></div>' +
          '<div class="ysl-mq__ractions">' +
            '<button type="button" class="ysl-btn ysl-btn--dark ysl-mq__share">CHIA SẺ NGAY</button>' +
            '<button type="button" class="ysl-btn ysl-btn--outline ysl-mq__restart">THỰC HIỆN LẠI</button>' +
          '</div>' +
          renderStores() +
        '</div>';

      var shareBtn = $('.ysl-mq__share', resultScreen);
      if (shareBtn) shareBtn.addEventListener('click', share);
      var restartBtn = $('.ysl-mq__restart', resultScreen);
      if (restartBtn) restartBtn.addEventListener('click', restart);
    }

    function renderStores() {
      var stores = data.stores || [];
      if (!stores.length) return '';
      var groups = {};
      stores.forEach(function (s) { (groups[s.city] = groups[s.city] || []).push(s); });
      var inner = '';
      Object.keys(groups).forEach(function (city) {
        inner += '<p class="ysl-mq__store-city">' + esc(city) + '</p>';
        groups[city].forEach(function (s) {
          inner += '<div class="ysl-mq__store"><span class="ysl-mq__store-name">' + esc(s.name) + '</span>' +
            '<span class="ysl-mq__store-addr">' + esc(s.address) + '</span></div>';
        });
      });
      return '<div class="ysl-mq__stores">' +
        '<p class="ysl-mq__stores-h">BẠN CHƯA CHẮC CHẮN?</p>' +
        '<p class="ysl-mq__stores-sub">Hãy tới cửa hàng để nhận ngay vial và trải nghiệm thêm</p>' +
        '<div class="ysl-mq__stores-card"><p class="ysl-mq__stores-title">THÔNG TIN CỬA HÀNG</p>' + inner + '</div></div>';
    }

    function share() {
      var r = RESULTS[resultKey];
      var txt = 'Nốt hương đại diện cho tôi là MYSLF ' + r.variant + ' — ' + r.title + '. #FeelMYSLF';
      if (navigator.share) {
        navigator.share({ title: 'FEEL MYSLF', text: txt, url: location.href }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(txt + ' ' + location.href).then(function () {
          var b = $('.ysl-mq__share', resultScreen); if (b) { b.textContent = 'ĐÃ SAO CHÉP'; setTimeout(function () { b.textContent = 'CHIA SẺ NGAY'; }, 1800); }
        });
      }
    }

    function restart() {
      answers = {}; resultKey = null; idx = 0; render(); stage.scrollTop = 0;
    }

    function next() { if (idx < seq.length - 1) { idx++; render(); stage.scrollTop = 0; } }
    function prev() { if (idx > 0) { idx--; render(); stage.scrollTop = 0; } }
    btnBack.addEventListener('click', prev);

    // If the Shopify customer form just posted successfully, skip intro+form
    // and drop the user straight into Q1. Shopify reloads with ?customer_posted=true.
    if (root.getAttribute('data-form-success') === 'true' || /[?&](customer|contact)_posted=true/.test(location.search)) {
      idx = 2; // first 'title' step
    }
    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.ysl-mq'), function (root) {
      if (root.__mqInit) return; root.__mqInit = true; init(root);
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
